import Vue from 'vue'
import Router from 'vue-router'
import Works from './views/Works'
import Login from './views/Login'
import Layout from './views/Layout'
import Details from './views/Details'
import store from './store'
import AuthService from './services/auth_service'
import WorkService from './services/work_service'
import DateService from './services/date_service'
import DetailService from './services/detail_service'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/works',
      name: 'layout',
      component: Layout,
      children: [
        {
          path: 'works',
          component: Works,
          beforeEnter: async (to, from, next) => {
            // Est-ce que l'utilisateur authentifié est un élève ?
            if (store.state.auth.user.permissionLevel === 0) {
              console.log('fetch works')
              store.dispatch('work/setLoading', true)
              const response = await WorkService.getWorks(store.state.auth.user.login)
              if (response) {
                const data = DateService.formatObjectArrayDatesToDisplayFormat(response.data.data, 'display')
                store.dispatch('work/setWorksData', data)
                // Trier par ordre chronologique décroissant
                store.dispatch('work/sortWorksNonChronological')
                store.dispatch('work/setLoading', false)
                next()
              }
            } else {
              // L'utilisateur authentifié est enseignant
              console.log('fetch pending comments')
              const response = await DetailService.getPendingRemediation(store.state.auth.user.login)
              if (response) {
                const data = DateService.formatObjectArrayDatesToDisplayFormat(response.data.data, 'display')
                store.dispatch('remediation/setRemediationData', data)
                // Trier par ordre chronologique décroissant
                store.dispatch('remediation/sortRemediationNonChronological')
                next()
              }
            }
            store.dispatch('work/setSelectedWork', undefined)
            store.dispatch('detail/setDetailsData', undefined)
          }
        },
        {
          path: 'details/:numero',
          component: Details,
          beforeEnter: async (to, from, next) => {
            store.dispatch('detail/setOngoingAlteredRow', false)
            store.dispatch('detail/setNullSelectedRow')
            const numero = Number(to.params.numero)
            // Est-ce qu'une autre page a été ouverte précédemment ?
            // L'enseignant n'a pas forcément le travail dans worksData car il peut sélectionner des travaux depuis son dashboard
            if (store.state.work.worksData && store.state.auth.user.permissionLevel === 0) {
              // Récupérer les informations du travail renseigné
              const newData = [...store.state.work.worksData]
              const target = newData.filter(item => numero === item.numero)[0]
              store.dispatch('work/setSelectedWork', target)
            } else {
              // Récupérer les informations du travail sélectionné
              const response = await WorkService.getWork(to.params.numero)
              if (response) {
                const value = DateService.formatObjectArrayDatesToDisplayFormat(response.data.data, 'display')
                store.dispatch('work/setSelectedWork', value[0])
              } else {
                next('/works')
              }
            }
            next()
          }
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    }
  ]
})

/**
 * Middleware des routes : gère la vérification de l'authentification
 */
router.beforeEach(async (to, from, next) => {
  const refreshToken = localStorage.getItem('refreshToken')
  if (refreshToken) {
    // user présent dans vuex auth ?
    if (store.state.auth.user) {
      // Route cible est /login ?
      to.path === '/login' ? next('/works') : next()
    } else {
      // API : récupère un access_token
      const response = await AuthService.renewAccessToken(refreshToken)
      if (response) {
        const data = response.data.data
        // Set refreshToken dans localstorage
        localStorage.setItem('refreshToken', data.refresh_token)
        // Peupler user avec les information codée du token
        store.dispatch('auth/setUserFromToken', data.access_token)
        const token = {
          accessToken: data.access_token,
          expiresIn: data.expires_in
        }
        store.dispatch('auth/setUserToken', token)
        to.path === '/login' ? next('/works') : next()
      } else {
        store.dispatch('auth/diconnectUser')
        next('/login')
      }
    }
  } else {
    // Route cible est /login ?
    to.path === '/login' ? next() : next('/login')
  }
})
export default router
